import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { CustomCssSiteConfig, CustomCssData } from '../types'
import { CUSTOM_CSS_APP_ID } from '../constants'
import type { TPAPublicClientSpecEntry } from '@wix/thunderbolt-ssr-api'

const customCssSiteConfig: SiteConfigFn<CustomCssSiteConfig> = ({ api }) => {
	// Get gridAppId from wixCodeModel
	const wixCodeModel = api.rendererModel.getWixCodeModel()
	const gridAppId = wixCodeModel?.appData?.codeAppId || ''

	// Check if CUSTOM_CSS_APP is on site
	const pagesPlatformApplications = api.rendererModel.getPagesPlatformApplications() || {}
	const appsOnSite: string[] = []
	for (const apps of Object.values(pagesPlatformApplications)) {
		if (Array.isArray(apps)) {
			appsOnSite.push(...apps)
		}
	}
	const shouldLoadGlobalCssFile = appsOnSite.includes(CUSTOM_CSS_APP_ID)

	// Get apps with custom CSS from clientSpecMap
	const clientSpecMap = api.rendererModel.getClientSpecMap() || {}
	const appsWithCustomCss: { [appDefId: string]: CustomCssData } = {}

	for (const [, spec] of Object.entries(clientSpecMap)) {
		const appDefinitionId = (spec as TPAPublicClientSpecEntry).appDefinitionId
		const widgets = (spec as TPAPublicClientSpecEntry).widgets || {}

		// Find first widget with veloCustomCss
		let customCssData: CustomCssData | undefined

		for (const widget of Object.values(widgets)) {
			const veloCustomCss = (widget as any)?.componentFields?.veloCustomCss
			if (veloCustomCss) {
				customCssData = veloCustomCss
				break // Take first widget (head() in Carmi)
			}
		}

		if (customCssData) {
			appsWithCustomCss[appDefinitionId] = customCssData
		}
	}

	const shouldLoadAppsCssFiles = Object.keys(appsWithCustomCss).length > 0
	const shouldLoadFeature = shouldLoadGlobalCssFile || shouldLoadAppsCssFiles

	// Get baseUrl
	const baseUrl = api.publicModel.getExternalBaseUrl()

	// Determine gridAppId based on whether global CSS file should load
	const gridAppIdOutput: string = shouldLoadGlobalCssFile ? gridAppId : ''

	const siteConfig: CustomCssSiteConfig = {
		gridAppId: gridAppIdOutput,
		appsWithCustomCss,
		baseUrl,
	}

	return {
		shouldLoadSiteFeature: shouldLoadFeature,
		shouldLoadSiteConfig: shouldLoadFeature,
		siteConfig,
	}
}

const name = 'customCss'

export const config = { site: customCssSiteConfig, name }
